"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var colors_1 = __importDefault(require("../../../theme/colors"));
var Breadcrumb = function (_a) {
    var gap = _a.gap, children = _a.children, separator = _a.separator, separatorColor = _a.separatorColor;
    if (!react_1.isValidElement(children)) {
        return null;
    }
    return (theme_ui_1.jsx(theme_ui_1.Box, { as: "li", sx: {
            listStyle: "none",
            ":not(:last-of-type):after": {
                content: "\"" + separator + "\"",
                margin: "0 " + gap,
                display: "inline-block",
                color: colors_1.default[separatorColor],
            }
        } }, react_1.cloneElement(children, {
        sx: {
            listStyle: "none"
        }
    })));
};
exports.Breadcrumb = Breadcrumb;
